'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'

type Props = {
  isOpen: boolean
  refundOfferId?: number | null
  isDataLoading: boolean
  onSubmit: () => void
  onClose: () => void
}

const DeclinePartialRefundOfferDialog = ({
  isOpen,
  isDataLoading,
  refundOfferId,
  onSubmit,
  onClose,
}: Props) => {
  const translate = useTranslate('decline_partial_refund_offer_dialog')

  if (isDataLoading)
    return (
      <Dialog show={isOpen}>
        <ContentLoader />
      </Dialog>
    )

  if (!refundOfferId) return null

  return (
    <Dialog
      show={isOpen}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('actions.decline'),
          style: Dialog.ActionStyling.Filled,
          callback: onSubmit,
          testId: 'decline-partial-refund-dialog-submit-button',
        },
        {
          text: translate('actions.cancel'),
          style: Dialog.ActionStyling.Flat,
          callback: onClose,
        },
      ]}
    />
  )
}

export default DeclinePartialRefundOfferDialog
